module.exports = __webpack_public_path__ + "media/images/wind-2dd7ca5a6f10bc5ed67e7dfdfdbb7e1d.png";